import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';

const eidDates = [
  { name: 'Eid ul Fitr 2026', date: new Date('2026-03-20T06:00:00'), path: '/eid-ul-fitr', label: 'Zuckerfest' },
  { name: 'Eid ul Adha 2026', date: new Date('2026-05-27T06:00:00'), path: '/eid-ul-adha', label: 'Opferfest' },
];

const getNextEid = () => {
  const now = new Date();
  return eidDates.filter(e => e.date > now).sort((a, b) => a.date - b.date);
};

const calcTimeLeft = (target) => {
  const diff = target - new Date();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const TimeBox = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="font-serif text-2xl sm:text-3xl md:text-4xl font-medium text-white tabular-nums">{String(value).padStart(2, '0')}</span>
    <span className="text-[10px] sm:text-xs uppercase tracking-wider text-white/60 mt-1">{label}</span>
  </div>
);

export const EidCountdown = () => {
  const upcoming = getNextEid();
  const [timeLeft, setTimeLeft] = useState(() => upcoming[0] ? calcTimeLeft(upcoming[0].date) : null);

  useEffect(() => {
    if (!upcoming.length) return;
    const target = upcoming[0].date;
    const timer = setInterval(() => setTimeLeft(calcTimeLeft(target)), 1000);
    return () => clearInterval(timer);
  }, [upcoming]);

  if (!upcoming.length || !timeLeft) return null;

  const nextEid = upcoming[0];

  return (
    <section className="bg-[#4A5D4F] py-8 md:py-10" data-testid="eid-countdown">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3 text-white">
            <Clock className="w-5 h-5 text-[#D4C5A9]" />
            <div>
              <p className="text-sm text-white/70">{nextEid.label}</p>
              <p className="font-serif text-lg md:text-xl font-medium">{nextEid.name}</p>
            </div>
          </div>

          <div className="flex items-center gap-4 sm:gap-6">
            <TimeBox value={timeLeft.days} label="Tage" />
            <span className="text-white/40 text-2xl font-light">:</span>
            <TimeBox value={timeLeft.hours} label="Std" />
            <span className="text-white/40 text-2xl font-light">:</span>
            <TimeBox value={timeLeft.minutes} label="Min" />
            <span className="text-white/40 text-2xl font-light hidden sm:block">:</span>
            <div className="hidden sm:block"><TimeBox value={timeLeft.seconds} label="Sek" /></div>
          </div>

          <Link to={nextEid.path} className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-full text-sm font-medium transition-colors" data-testid="countdown-cta">
            Geschenke ansehen <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {upcoming.length > 1 && (
          <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-center gap-2 text-white/50 text-xs">
            <span>Danach: {upcoming[1].name} ({upcoming[1].label})</span>
          </div>
        )}
      </div>
    </section>
  );
};
